import { render, staticRenderFns } from "./YueDuXuanZe.vue?vue&type=template&id=3abbf998&scoped=true"
import script from "./YueDuXuanZe.vue?vue&type=script&lang=js"
export * from "./YueDuXuanZe.vue?vue&type=script&lang=js"
import style0 from "./YueDuXuanZe.vue?vue&type=style&index=0&id=3abbf998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abbf998",
  null
  
)

export default component.exports